// Detection for playable promo video URLs, mirroring
// backend/src/lib/video/videoUrl.js so upload validation matches the API.

export function isDirectVideo(url) {
  return Boolean(url && (/\.(mp4|webm|mov)/i.test(url) || url.includes('cloudinary')));
}

// Matches watch, share (youtu.be), embed, shorts and live links. The share
// links carry a `?si=` tracking param, so the id has to be length-bounded
// rather than "everything up to the next &".
const YOUTUBE_ID_RE = /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|v\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})(?![\w-])/;

export function youTubeId(url) {
  const match = url && url.match(YOUTUBE_ID_RE);
  return match ? match[1] : null;
}

export function isYouTube(url) {
  return Boolean(youTubeId(url));
}

function hostnameOf(url) {
  try { return new URL(url).hostname; } catch { return ''; }
}

export function isSocialEmbedUrl(url) {
  return Boolean(url && /(^|\.)(instagram\.com|facebook\.com|fb\.watch)/i.test(hostnameOf(url)));
}

export function isPlayableVideoUrl(url) {
  return isYouTube(url) || isDirectVideo(url);
}

export const SOCIAL_VIDEO_URL_MESSAGE =
  "Instagram and Facebook links can't be embedded. Please upload the video file directly, "
  + 'or paste a YouTube or direct video (.mp4) URL.';

export const YOUTUBE_NO_ID_MESSAGE =
  "That YouTube link doesn't contain a video id. Open the video on YouTube and copy the "
  + 'link from the address bar or the Share button.';

export const UNSUPPORTED_VIDEO_URL_MESSAGE =
  'This link cannot be played. Upload the video file directly, or paste a YouTube link '
  + 'or a direct video (.mp4/.webm/.mov) / Cloudinary URL.';

export function videoUrlRejectionReason(url) {
  if (isPlayableVideoUrl(url)) return null;
  if (isSocialEmbedUrl(url)) return SOCIAL_VIDEO_URL_MESSAGE;
  if (/(^|\.)(youtube\.com|youtu\.be)$/i.test(hostnameOf(url))) return YOUTUBE_NO_ID_MESSAGE;
  return UNSUPPORTED_VIDEO_URL_MESSAGE;
}
